import React, {
  useMemo,
  useState,
} from "react";

import ReactDOM from "react-dom";

import {
  FiEdit,
  FiPlus,
  FiSave,
  FiTrash2,
  FiX,
} from "react-icons/fi";

import API from "../../../../../../utils/apiCalling";

import {
  config,
} from "../../../../../../utils/apiUrl";

import EmployeeConfirmModal
  from "../common/EmployeeConfirmModal";

import {
  getEmployeeApiError,
} from "../utils/employee.utils";

import "./EmployeeLeave.css";


const INITIAL_FORM = {
  name: "",
  code: "",
  description: "",
  allowedDays: "",
  isPaid: true,
  carryForward: false,
  maxCarryForwardDays: "",
  status: "ACTIVE",
};


const LeaveTypeModal = ({
  open,

  leaveTypes = [],

  onClose,

  onSuccess,
}) => {

  const api =
    useMemo(
      () =>
        new API(),
      []
    );


  const [
    form,
    setForm,
  ] =
    useState({
      ...INITIAL_FORM,
    });


  const [
    editing,
    setEditing,
  ] =
    useState(null);


  const [
    loading,
    setLoading,
  ] =
    useState(false);


  const [
    error,
    setError,
  ] =
    useState("");


  const [
    deleteTarget,
    setDeleteTarget,
  ] =
    useState(null);


  if (
    !open
  ) {

    return null;

  }


  const resetForm =
    () => {

      setForm({
        ...INITIAL_FORM,
      });


      setEditing(
        null
      );


      setError(
        ""
      );

    };


  const handleEdit = (
    type
  ) => {

    setEditing(
      type
    );


    setForm({
      name:
        type?.name ||
        "",

      code:
        type?.code ||
        "",

      description:
        type?.description ||
        "",

      allowedDays:
        String(
          type?.allowedDays ??
          type?.annualDays ??
          ""
        ),

      isPaid:
        Boolean(
          type?.isPaid
        ),

      carryForward:
        Boolean(
          type?.carryForward
        ),

      maxCarryForwardDays:
        String(
          type?.maxCarryForwardDays ??
          ""
        ),

      status:
        type?.status ||
        "ACTIVE",
    });

  };


  const handleSubmit =
    async (
      event
    ) => {

      event.preventDefault();


      if (
        !form.name.trim()
      ) {

        setError(
          "Leave type name is required."
        );

        return;

      }


      if (
        !form.code.trim()
      ) {

        setError(
          "Leave type code is required."
        );

        return;

      }


      if (
        Number(
          form.allowedDays
        ) <
        0
      ) {

        setError(
          "Allowed days cannot be negative."
        );

        return;

      }


      try {

        setLoading(
          true
        );


        setError(
          ""
        );


        const payload = {
          name:
            form.name.trim(),

          code:
            form.code
              .trim()
              .toUpperCase()
              .replace(
                /\s+/g,
                "_"
              ),

          description:
            form.description.trim(),

          allowedDays:
            Number(
              form.allowedDays ||
              0
            ),

          isPaid:
            form.isPaid,

          carryForward:
            form.carryForward,

          maxCarryForwardDays:
            form.carryForward
              ?
              Number(
                form.maxCarryForwardDays ||
                0
              )
              :
              0,

          status:
            form.status,
        };


        const response =
          editing
            ?
            await api.put(
              config.updateEmployeeLeaveType(
                editing._id
              ),
              payload
            )
            :
            await api.post(
              config.createEmployeeLeaveType,
              payload
            );


        if (
          response?.status !==
          "success"
        ) {

          throw new Error(
            response?.message ||
            "Unable to save leave type."
          );

        }


        resetForm();


        await onSuccess?.();

      } catch (
        requestError
      ) {

        setError(
          getEmployeeApiError(
            requestError,
            "Unable to save leave type."
          )
        );

      } finally {

        setLoading(
          false
        );

      }

    };


  const handleDelete =
    async () => {

      if (
        !deleteTarget?._id
      ) {

        return;

      }


      try {

        setLoading(
          true
        );


        const response =
          await api.delete(
            config.deleteEmployeeLeaveType(
              deleteTarget._id
            )
          );


        if (
          response?.status !==
          "success"
        ) {

          throw new Error(
            response?.message ||
            "Unable to delete leave type."
          );

        }


        setDeleteTarget(
          null
        );


        await onSuccess?.();

      } catch (
        requestError
      ) {

        setError(
          getEmployeeApiError(
            requestError,
            "Unable to delete leave type."
          )
        );

      } finally {

        setLoading(
          false
        );

      }

    };


  return ReactDOM
    .createPortal(

      <>

        <div className="employee-leave-modal-root">

          <button
            type="button"
            className="employee-leave-modal-backdrop"
            onClick={
              loading
                ?
                undefined
                :
                onClose
            }
          />


          <div className="employee-leave-type-modal">

            <header>

              <div>

                <span>
                  <FiPlus />
                </span>


                <div>

                  <small>
                    LEAVE CONFIGURATION
                  </small>

                  <h3>
                    Manage Leave Types
                  </h3>

                </div>

              </div>


              <button
                type="button"
                onClick={
                  onClose
                }
              >
                <FiX />
              </button>

            </header>


            <div className="employee-leave-type-body">

              <form
                onSubmit={
                  handleSubmit
                }
                className="employee-leave-type-form"
              >

                <div className="employee-leave-type-form-heading">

                  <strong>
                    {
                      editing
                        ?
                        "Edit Leave Type"
                        :
                        "New Leave Type"
                    }
                  </strong>

                  {
                    editing
                      ?
                      (
                        <button
                          type="button"
                          onClick={
                            resetForm
                          }
                        >
                          Cancel Edit
                        </button>
                      )
                      :
                      null
                  }

                </div>


                <div className="employee-leave-form-grid">

                  <div className="employee-leave-form-field">

                    <label>
                      Name *
                    </label>

                    <input
                      value={
                        form.name
                      }
                      onChange={
                        (
                          event
                        ) =>
                          setForm(
                            (
                              previous
                            ) => ({
                              ...previous,

                              name:
                                event
                                  .target
                                  .value,
                            })
                          )
                      }
                      placeholder="Casual Leave"
                    />

                  </div>


                  <div className="employee-leave-form-field">

                    <label>
                      Code *
                    </label>

                    <input
                      value={
                        form.code
                      }
                      onChange={
                        (
                          event
                        ) =>
                          setForm(
                            (
                              previous
                            ) => ({
                              ...previous,

                              code:
                                event
                                  .target
                                  .value
                                  .toUpperCase(),
                            })
                          )
                      }
                      placeholder="CL"
                    />

                  </div>


                  <div className="employee-leave-form-field">

                    <label>
                      Allowed Days / Year
                    </label>

                    <input
                      type="number"
                      min="0"
                      value={
                        form.allowedDays
                      }
                      onChange={
                        (
                          event
                        ) =>
                          setForm(
                            (
                              previous
                            ) => ({
                              ...previous,

                              allowedDays:
                                event
                                  .target
                                  .value,
                            })
                          )
                      }
                    />

                  </div>


                  <div className="employee-leave-form-field">

                    <label>
                      Status
                    </label>

                    <select
                      value={
                        form.status
                      }
                      onChange={
                        (
                          event
                        ) =>
                          setForm(
                            (
                              previous
                            ) => ({
                              ...previous,

                              status:
                                event
                                  .target
                                  .value,
                            })
                          )
                      }
                    >

                      <option value="ACTIVE">
                        Active
                      </option>

                      <option value="INACTIVE">
                        Inactive
                      </option>

                    </select>

                  </div>


                  <div className="employee-leave-form-full">

                    <label className="employee-leave-checkbox">

                      <input
                        type="checkbox"
                        checked={
                          form.isPaid
                        }
                        onChange={
                          (
                            event
                          ) =>
                            setForm(
                              (
                                previous
                              ) => ({
                                ...previous,

                                isPaid:
                                  event
                                    .target
                                    .checked,
                              })
                            )
                        }
                      />

                      <span />

                      <div>

                        <strong>
                          Paid Leave
                        </strong>

                        <small>
                          Employee salary is not deducted for approved leave.
                        </small>

                      </div>

                    </label>

                  </div>


                  <div className="employee-leave-form-full">

                    <label className="employee-leave-checkbox">

                      <input
                        type="checkbox"
                        checked={
                          form.carryForward
                        }
                        onChange={
                          (
                            event
                          ) =>
                            setForm(
                              (
                                previous
                              ) => ({
                                ...previous,

                                carryForward:
                                  event
                                    .target
                                    .checked,
                              })
                            )
                        }
                      />

                      <span />

                      <div>

                        <strong>
                          Carry Forward
                        </strong>

                        <small>
                          Allow unused leave to move to the next year.
                        </small>

                      </div>

                    </label>

                  </div>


                  {
                    form.carryForward
                      ?
                      (
                        <div className="employee-leave-form-field">

                          <label>
                            Maximum Carry Forward
                          </label>

                          <input
                            type="number"
                            min="0"
                            value={
                              form.maxCarryForwardDays
                            }
                            onChange={
                              (
                                event
                              ) =>
                                setForm(
                                  (
                                    previous
                                  ) => ({
                                    ...previous,

                                    maxCarryForwardDays:
                                      event
                                        .target
                                        .value,
                                  })
                                )
                            }
                          />

                        </div>
                      )
                      :
                      null
                  }


                  <div className="employee-leave-form-field employee-leave-form-full">

                    <label>
                      Description
                    </label>

                    <textarea
                      value={
                        form.description
                      }
                      onChange={
                        (
                          event
                        ) =>
                          setForm(
                            (
                              previous
                            ) => ({
                              ...previous,

                              description:
                                event
                                  .target
                                  .value,
                            })
                          )
                      }
                    />

                  </div>

                </div>


                {
                  error
                    ?
                    (
                      <div className="employee-leave-modal-error">
                        {error}
                      </div>
                    )
                    :
                    null
                }


                <button
                  type="submit"
                  className="employee-leave-type-save"
                  disabled={
                    loading
                  }
                >

                  <FiSave />

                  {
                    loading
                      ?
                      "Saving..."
                      :
                      editing
                        ?
                        "Update Leave Type"
                        :
                        "Add Leave Type"
                  }

                </button>

              </form>


              <div className="employee-leave-type-list">

                <div className="employee-leave-type-list-heading">

                  <strong>
                    Existing Leave Types
                  </strong>

                  <span>
                    {
                      leaveTypes.length
                    }
                  </span>

                </div>


                {
                  leaveTypes.length ===
                  0
                    ?
                    (
                      <div className="employee-leave-type-empty">
                        No leave types configured.
                      </div>
                    )
                    :
                    leaveTypes.map(
                      (
                        type
                      ) => (

                        <article
                          key={
                            type._id
                          }
                        >

                          <div>

                            <strong>
                              {type.name}
                            </strong>

                            <span>
                              {
                                type.code
                              }
                              {" • "}
                              {
                                Number(
                                  type?.allowedDays ??
                                  type?.annualDays ??
                                  0
                                )
                              }
                              {" days"}
                            </span>

                            <small>

                              {
                                type.isPaid
                                  ?
                                  "Paid"
                                  :
                                  "Unpaid"
                              }

                              {" • "}

                              {
                                type.status ||
                                "ACTIVE"
                              }

                            </small>

                          </div>


                          <div>

                            <button
                              type="button"
                              onClick={
                                () =>
                                  handleEdit(
                                    type
                                  )
                              }
                            >

                              <FiEdit />

                            </button>


                            <button
                              type="button"
                              onClick={
                                () =>
                                  setDeleteTarget(
                                    type
                                  )
                              }
                            >

                              <FiTrash2 />

                            </button>

                          </div>

                        </article>

                      )
                    )
                }

              </div>

            </div>

          </div>

        </div>


        <EmployeeConfirmModal
          open={
            Boolean(
              deleteTarget
            )
          }
          title="Delete Leave Type"
          description="Delete this leave type? Existing historical leave records should remain preserved by the backend."
          confirmLabel="Delete"
          danger
          loading={
            loading
          }
          onClose={
            () =>
              setDeleteTarget(
                null
              )
          }
          onConfirm={
            handleDelete
          }
        />

      </>,

      document.body

    );

};


export default LeaveTypeModal;